import { HorizontalAlignment, ModelRow, Navigation } from "@mcleod/core";
import { ClickEvent, Label, Layout, SlideoutDecorator, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutEdiBatchHistoryQuickInfoTable } from "./autogen/AutogenLayoutEdiBatchHistoryQuickInfoTable";

import { TransmissionControlExpanded } from "./TransmissionControlExpanded";

export class EdiBatchHistoryQuickInfoTable extends AutogenLayoutEdiBatchHistoryQuickInfoTable {
    private _transmissionStatusURL = "lme/datafusion/TransmissionControlList?ids="

    onLoad(): void | Promise<void> {
        for (const column of this.tableBatchHistory.columns) {
            column.headingCell.align = HorizontalAlignment.LEFT;
        }
    }

    onLoadDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelBatch = tableRow.findComponentById("labelBatch") as Label;
        labelBatch.addUnderlineWhenMouseOver();
    }

/** This is an event handler for the onClick event of . */
  OnClick(event: ClickEvent) {
      const tableRow = event.target as TableRow;
      const modelRow = tableRow.data as ModelRow;
      const ediLogId = modelRow.get("edi_log.id");
      const layout = Layout.getLayout("lme/datafusion/TransmissionControlExpanded", {
          width: window.innerWidth * 0.75,
          backgroundColor: "defaultBackground",
          fillHeight: true,
          paddingBottom: 50
      }) as TransmissionControlExpanded;
      layout.logId = ediLogId;
      new SlideoutDecorator({
          layout,
          title: "Transmission Control",
          fillVerticalSpace: true,
          doAfterSlideIn: async (decorator: SlideoutDecorator) => {
              layout.sourceTransmissionControlList.search({ ids: ediLogId }).then(() => {
                  layout.setupLayoutByEdiLogId();
              });
          }
      });
  }

/** This is an event handler for the onClick event of imagePopOut. */
    imagePopOutOnClick(event: ClickEvent) {
        const ediLogIds: string[] = this.tableBatchHistory.rows
            .map((row: TableRow) => {
                const modelRow = row.data as ModelRow;
                return modelRow.get("edi_log.id");
            })
            .filter((id: string | undefined) => id !== undefined);

        const url = this._transmissionStatusURL ;
        Navigation.navigateTo(url + encodeURIComponent(ediLogIds.join(",")),  { newTab: true});
    }
}
